import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import cx from 'classnames';
import React from 'react';

var Input =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Input, _React$Component);

  function Input() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Input.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        inputRef = _this$props.inputRef,
        props = _objectWithoutPropertiesLoose(_this$props, ["className", "inputRef"]);

    return React.createElement("input", _extends({}, props, {
      className: cx('rbt-input-main', className),
      ref: inputRef
    }));
  };

  return Input;
}(React.Component);

export default Input;